/**
 * Extrae el mensaje de error real que envió el backend (NestJS) para mostrarlo
 * tal cual al usuario, en vez de un texto genérico que oculta la causa
 * (campo faltante, permisos insuficientes, regla de negocio, etc.).
 *
 * Soporta las formas que puede tomar `response.data`:
 * - string:            BadRequestException('mensaje')
 * - string[]:          ValidationPipe (uno por campo inválido)
 * - { code, message }: excepciones estructuradas (ForbiddenException con objeto)
 */
export function getErrorMessage(error: unknown, fallback = 'Ocurrió un error inesperado'): string {
  const response = (error as any)?.response;
  const data = response?.data;
  let message: unknown = data?.message ?? data?.error;

  if (message && typeof message === 'object' && !Array.isArray(message)) {
    message = (message as any).message ?? (message as any).code;
  }
  if (Array.isArray(message)) {
    message = message.filter(Boolean).join('. ');
  }
  if (typeof message === 'string' && message.trim()) {
    return message;
  }

  // Sin respuesta del servidor: red caída, timeout, CORS, etc.
  if (!response && typeof (error as any)?.message === 'string') {
    return (error as any).message === 'Network Error'
      ? 'No se pudo conectar con el servidor. Verifica tu conexión.'
      : fallback;
  }

  return fallback;
}
